import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import { withFormikDevtools } from 'formik-devtools-extension';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import { set } from 'lodash';
import { isProduction } from 'src/config/index';
import { CaseYupSchema } from '../CasePropTypes';
import { useDispatch, useSelector } from 'react-redux';
import { shallowEqual } from 'recompose';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { cloneDeep } from 'lodash-es';
import SearchContainer from '../../search-container/SearchContainer';
import { CoApplicantRemoveAction, caseUpsertAction } from '../actions/CaseActions';
import CustomerForm from 'src/containers/customer-container/CustomerForm';
import { customerSearchAction } from 'src/containers/customer-container/actions/CustomerActions';
import RoutingUtil from 'src/utils/RoutingUtil';
import CustomerDropDown from 'src/business-components/CustomerDropDown';
import FormikCheckBox from 'src/components/formik/FormikCheckBox';
import { RELATION_TYPES } from '../CaseConstants';
import FormikSelect from 'src/components/formik/FormikSelect';

const columns = {
    firstName: {
        display: 'First Name',
    },
    lastName: {
        display: 'Last Name',
    },
    phone: {
        display: 'Phone',
    },
    email: {
        display: 'Email',
    },
    company: {
        display: 'Company',
    },
    designation: {
        display: 'Designation',
    },
    active: {
        display: 'Active',
    },
    by: {
        display: 'By',
        path: 'by.personalInfo.firstName',
    },
    updatedBy: {
        display: 'Updated By',
        path: 'updatedBy.personalInfo.firstName',
    },
    ts: {
        display: 'Ts',
        type: Date,
        format: DATE_TIME_FORMAT.TIMEAGO,
    },
    updatedTs: {
        display: 'Updated Ts',
        type: Date,
        format: DATE_TIME_FORMAT.TIMEAGO,
    },
};
const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
    } = props;

    return (
        <>
            <Form autoComplete="disabled">
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>Relation</label>
                        <FormikSelect
                            className="form-control"
                            items={RELATION_TYPES}
                            name="CoApplicantRelation"
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Customer</label>
                        <CustomerDropDown 
                        name="CoApplicantCustomerId"
                />
                    </div>
                    <div className="form-group">
                        <label className='col-md-12'>Other</label>
                        <FormikCheckBox
                            className="ml-2 big-checkbox ol-md-12"
                            name="isOther"
                        />
                    </div>
                </div>

                {
                    values.isOther ? (
                        <>
                            <CustomerForm />
                        </>
                    ) : (
                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-primary"
                            >
                                Add
                            </button>
                        </div>

                    )
                }
                <br />
            </Form>
        </>
    );
}
Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        agentId: PropTypes.string,
        caseCode: PropTypes.string,
    }).isRequired,
    onStageChange: PropTypes.func.isRequired,
};

let setSubmitting = () => { };

function CoApplicantForm() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { currentRecord, populatedCurrentRecord, upsertReqStatus } = useSelector((state) => state.CaseReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious(
        {
            currentRecord,
            upsertReqStatus,
        },
        (prev) => {
            if (
                prev.currentRecord !== currentRecord
                || (upsertReqStatus
                    && prev.upsertReqStatus !== upsertReqStatus
                    && upsertReqStatus !== REQUEST_STATUS.PENDING)
            ) {
                setSubmitting(false);
            }
        },
    );

    const onSubmit = (values, formikUtils) => {
        ({ setSubmitting } = formikUtils);
        const newRecord = cloneDeep(currentRecord);
        // includeStamp(newRecord);
        // includeStamp(values);
        if (!newRecord.CoApplicantDetails) {
            newRecord.CoApplicantDetails = [];
        }
        newRecord.CoApplicantDetails.push({
            customerId: values.CoApplicantCustomerId,
            relation: values.CoApplicantRelation
        });
        dispatch(caseUpsertAction(newRecord));
    };

    const onSearch = useCallback(({
    }) => {
        history.push(RoutingUtil.caseSearch({

        }));
    }, [
        history,
    ]);
    const onClear = useCallback(() => {

    }, [
        dispatch,
    ]);

    const onRemove = useCallback((
        {_id}        
    ) => {
        dispatch(CoApplicantRemoveAction({
            caseId:currentRecord._id,
            _id, 
        }));

    }, [
        currentRecord,
        dispatch
    ]);

    const where = useMemo(() => {
        const whereCond = {};
        const userIds = currentRecord?.CoApplicantDetails.map((user) => {
            return user.customerId;
        }) || [];
        set(whereCond, '_id', { $in: userIds });
        return whereCond;
    }, [
        currentRecord
    ]);

    return (
        <div className="mt-3">
            <div className="card mt-3">
                <div className="card-body">
                    <h5 className="card-title">
                        <i className="fas fa-file text-info" />
                        {' '}
                        Co Applicant Details
                    </h5>
                    <Formik
                        onSubmit={onSubmit}
                        onClear={onClear}
                        enableReinitialize
                        initialValues={currentRecord}
                        validationSchema={CaseYupSchema}
                        onSearch={onSearch}
                    >
                        {(formikProps) => (
                            <Render
                                onClear={onClear}
                                onSearch={onSearch}
                                {...formikProps}
                            />
                        )}
                    </Formik>
                    <SearchContainer
                        fullTextSearch={false}
                        className="mt-3"
                        reducer="CustomerReducer"
                        // dataPath={dataPath}
                        dataPath="search"
                        action={customerSearchAction}
                        columns={columns}
                        queryParamsAsWhere={false}
                        where={where}
                        hasRemove
                        removeAction={onRemove}
                        rowDeletedCheckPath="deleted"
                    />
                </div>
            </div>
        </div>
    );
}

export default CoApplicantForm;
